import { object, string, number, boolean, ObjectSchema, InferType, date, mixed } from "yup";
import { LiquidarContasAReceberContract } from "../contracts/liquidar-contas-a-receber";
import { DiscountTypeEnum } from "../../../shared/utils/enum/enum";

export const LiquidarContasAReceberSchema: ObjectSchema<LiquidarContasAReceberContract> = object({
    paymentDate: date()
        .typeError("Informe uma data válida para o pagamento")
        .required("Informar a data de pagamento é obrigatório"),
    paidValue: number()
        .typeError("Valor total deve ser um número")
        .transform((value, originalValue) => {
            if (typeof originalValue === "string") {
                const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
                if (!cleaned) return undefined;
                const valorNumber = Number(cleaned);
                return isNaN(valorNumber) ? undefined : valorNumber;
            }
            return value;
        })
        .required("É obrigatório informar o valor da movimentação!")
        .default(0),
    additionValue: number()
        .typeError("Valor total deve ser um número")
        .transform((value, originalValue) => {
            if (typeof originalValue === "string") {
                const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
                if (!cleaned) return undefined;
                const valorNumber = Number(cleaned);
                return isNaN(valorNumber) ? undefined : valorNumber;
            }
            return value;
        })
        .required("É obrigatório informar o valor da movimentação!")
        .default(0),
    discountType: mixed<DiscountTypeEnum>().optional(),
    discountValue: number()
        .typeError("Valor total deve ser um número")
        .transform((value, originalValue) => {
            if (typeof originalValue === "string") {
                const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
                if (!cleaned) return undefined;
                const valorNumber = Number(cleaned);
                return isNaN(valorNumber) ? undefined : valorNumber;
            }
            return value;
        })
        .required("É obrigatório informar o valor da movimentação!")
        .default(0),
    isMovimentToBank: boolean()
        .required("Informar se a movimentação é para o banco é obrigatório"),
    idBank: string()
        .when("isMovimentToBank", {
            is: true,
            then: schema => schema.required("É obrigatório informar o banco"),
            otherwise: schema => schema.notRequired(),
        }),
    idAgency: string()
        .when("isMovimentToBank", {
            is: true,
            then: schema => schema.required("É obrigatório informar a agência"),
            otherwise: schema => schema.notRequired(),
        }),
    idAccount: string()
        .when("isMovimentToBank", {
            is: true,
            then: schema => schema.required("É obrigatório informar a conta"),
            otherwise: schema => schema.notRequired(),
        }),
});

export type LiquidarContasReceberFormData = InferType<typeof LiquidarContasAReceberSchema>;